import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppointmentManagementView from './EMR_FRONTEND_ASSIGNMENT';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppointmentManagementView />
  </React.StrictMode>
);